import React, { useEffect, useState } from "react";

function AlertMessage({ type, text }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (text) {
      setVisible(true);
      // محو شدن خودکار بعد از 3 ثانیه
      const timer = setTimeout(() => setVisible(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [text]);

  if (!text) return null;

  // تنظیم رنگ‌ها بر اساس نوع پیام
  const styles = {
    success: {
      background: "#e6ffed",
      border: "#52c41a",
      text: "#237804",
    },
    error: {
      background: "#fff1f0",
      border: "#ff4d4f",
      text: "#a8071a",
    },
    warning: {
      background: "#fffbe6",
      border: "#faad14",
      text: "#ad6800",
    },
  };

  const { background, border, text: textColor } = styles[type] || styles.error;

  return (
    <div
      style={{
        padding: "12px 16px",
        marginBottom: 10,
        color: textColor,
        backgroundColor: background,
        border: `1px solid ${border}`,
        borderRadius: 6,
        fontSize: "14px",
        fontWeight: 500,
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        opacity: visible ? 1 : 0,
        transition: "opacity 0.5s ease-in-out",
      }}
    >
      {text}
    </div>
  );
}

export default AlertMessage;
